import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {NgForm} from "@angular/forms";
import {ActivatedRoute} from "@angular/router";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import BasePtpForm from "../base-ptp-form";
import {PerFormaAPIService} from "src/app/services/pfapi.service";

@Component({
    selector: "app-order-monitor",
    templateUrl: "./order-monitor.component.html",
    styleUrls: ["./order-monitor.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OrderMonitorComponent extends BasePtpForm implements OnInit {
    constructor(
        api: PerFormaAPIService,
        private route: ActivatedRoute,
        protected modal: NgbModal
    ) {
        super(api, modal);
    }

    ModalOptions = {animation: false, backdropClass: "backdrop"};
    PO: any = {};
    NewRequest: any = {};
    POID;

    Refresh() {
        this.getData();
    }

    ngOnInit(): void {
        window.addEventListener("message", event => {
            if (event?.data?.action === "SaveForm") {
                this.Update(() => {
                    window.parent.postMessage({...event.data, action: "LoadForm"});
                });
            }
        });

        // get the query params
        const params = new URL(window.location.toString()).searchParams;

        const show = params.get("show") ?? "";

        if (show != "") {
            this.DoScroll = true;
            this.ScrollTo = show;
        }

        this.route.queryParams.subscribe(f => {
            if (f.poid) {
                this.POID = f.poid;
                this.getData();
            }
        });
    }

    getData = () => {
        this.api.getApiPTPGetOrderMonitor({poId: this.POID}).subscribe(data => {
            this.PO = data;
            this.Loading = false;

            // see if we need to scroll
            if (this.DoScroll && this.ScrollTo?.length > 0) {
                setTimeout(() => {
                    this.ScrollToElement(this.ScrollTo);
                }, 500);
            }
        });
    };

    // Shows the create track window and scrolls to the top.
    ShowCreateTrack = tmpl => {
        this.NewRequest = {};
        this.modal.open(tmpl, this.ModalOptions);
        window.parent.scrollTo({top: 0, behavior: "smooth"});
    };

    // Updates the PO request with the scope model.
    Update = (next?: () => void) => {
        this.Loading = true;
        this.api.postApiPTPUpdateOrderMonitor(this.PO).subscribe(
            next ??
                (() => {
                    this.getData();
                    this.Success("Updated successfully");
                    this.Loading = false;
                })
        );
    };

    Success = message => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-expect-error
        window.parent.successAlert(message);
    };

    // Removes an item from the list of line items.
    RemoveItem = item => {
        for (let i = this.PO.Trackings.length; i--; ) {
            if (this.PO.Trackings[i] == item) {
                this.PO.Trackings.splice(i, 1);
                break;
            }
        }
    };

    // Adds an item to the list of line items.
    AddItem = (trackForm: NgForm, item) => {
        if (!trackForm.valid) return;
        this.PO.Trackings.push({
            TrackingID: 0,
            TrackingNumber: item.TrackingNumber,
            ShippedVia: item.ShippedVia
        });

        item.TrackingNumber = "";
        item.ShippedVia = "";

        this.modal.dismissAll();
    };
}
